export default __webpack_public_path__ + "5b180dc644c11a57f56d913c7f266f52.svg";